import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { ILopReducer } from "../../reducer-model/category/ILopReducer";
import { ILopActionTypes } from "../../action-types/category/ILopActions";

const iniState: ILopReducer = {
    status: eReducerStatusBase.is_not_initialization,
    lops: [],
}
export const lopReducer = (state: ILopReducer = iniState, action: ILopActionTypes): ILopReducer => {
    switch (action.type) {
        case "LOP_LOAD_LOP_BY_USER_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "LOP_LOAD_LOP_BY_USER_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lops: action.payload,
            }
        case "LOP_LOAD_LOP_BY_USER_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        case "LOP_LOAD_ALL_START":
            return {
                ...state,
                status: eReducerStatusBase.is_loading,
            }
        case "LOP_LOAD_ALL_SUCCESS":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
                lops: action.payload,
            }
        case "LOP_LOAD_ALL_ERROR":
            return {
                ...state,
                status: eReducerStatusBase.is_completed,
            }
        default:
            return state;
    }
}